<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="660"
    v-model="aboutShow"
    persistent
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar color="header" style="font-size: 20px" dark>{{
        $tc("nav.title")
      }}</v-toolbar>
      <div class="d-flex justify-center">
        <div v-show="$vuetify.breakpoint.smAndUp" style="min-width: 300px">
          <v-img
            src="../../assets/logo_DigicardSinSistemas.png"
            max-height="100"
            max-width="250"
            class="mt-6 mb-5 mx-auto"
          />
        </div>
        <v-row class="ma-0 my-auto">
          <v-card-text
            class="card-text py-0 ma-auto mb-1 d-flex justify-space-between"
          >
            {{ $tc("nav.versionCurrent") }} :
            <b>{{ version }}</b>
          </v-card-text>
          <v-card-text
            class="card-text py-0 ma-auto mt-1 d-flex justify-space-between"
          >
            {{ $tc("nav.versionAvailable") }} :
            <b>{{ getAppVersion }}</b>
          </v-card-text>
        </v-row>
      </div>

      <v-card-actions class="justify-center">
        <v-btn text @click="cancel">{{ $tc("newController.close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import login from "../../store/login/login";
const packageJson = require("../../../package.json");

export default {
  data() {
    return {
      version: packageJson.version,
    };
  },
  props: { about: Boolean },
  computed: {
    aboutShow: {
      get() {
        return this.about;
      },
      set(newValue) {
        this.$emit("change", newValue);
      },
    },
    getAppVersion() {
      return login.state.version.name;
    },
  },
  async mounted() {
    await login.dispatch("getAppVersion");
  },
  methods: {
    cancel() {
      this.aboutShow = false;
    },
  },
};
</script>

<style scoped>
.card-text {
  font-size: 20px;
  text-align: center !important;
}
</style>
